import { render } from "./Authriz.vue?vue&type=template&id=4263c46a&scoped=true"
import script from "./Authriz.vue?vue&type=script&lang=js"
export * from "./Authriz.vue?vue&type=script&lang=js"

import "./Authriz.vue?vue&type=style&index=0&id=4263c46a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4263c46a"]])

export default __exports__